/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Button, Card, CardContent, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridSearchIcon } from "@mui/x-data-grid";
import axios from "axios";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useState } from "react";
import { createTheme } from "react-data-table-component";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import useFeatureAccess from "utils/useFeatureAccess";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import Swal from "sweetalert2";
import { downloadInvoice } from "utils/api";
import { fetchInvoicePdfTheme } from "utils/api";
import { generateDataList } from "utils/generic";
import InvoiceModal from "components/invoiceModal/invoiceModal";
import { getScreenRight } from "utils/generic";
import { appConstants } from "utils/appConstants";
import LoadingModal from "components/LoadingModel/loadingModal";
import { ResendEmail } from "utils/invoiceAPI";
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EmailIcon from '@mui/icons-material/Email';
import DownloadIcon from '@mui/icons-material/Download';
import IconMenu from "components/CustomMaterialMenu/Custom";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import SearchField from "components/SearchField/SearchField";
import { AllKeysHaveValue } from "utils/generic";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import { toast } from "react-toastify";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { use } from "react";
import { formatCurrencyAUD } from "utils/formatCurrency";
const SCREEN_NAME = "Debts";
let SCREEN_RIGHT;

createTheme(
  'solarized',
  {
    text: {
      primary: 'white',
      secondary: 'white',
    },
    background: {
      default: '#202940',
    },
    context: {
      background: '#202940',
      text: 'white',
    },
    divider: {
      default: 'white',
    },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);
createTheme(
  'light',
  {
    text: {
      primary: 'black',
      secondary: 'black',
    },
    background: {
      default: 'white',
    },
    context: {
      background: 'white',
      text: 'black',
    },
    divider: {
      default: 'gray',
    },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);

function InvoicesDebts() {
  let currency = useSelector((state) => state.currency.currencySymbol);
  const featureAccess = useFeatureAccess();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [title, setTitle] = useState("");
  const [themeName, setThemeName] = useState([]);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [displayDialogeFlag, setDisplayDialogeFlag] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const dispatch = useDispatch();
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  const [values, setValues] = useState({
    _id: [],
    businessUserID: loginDetails?.businessUserID,
    sortingType: "",
    sortingField: "",
    invoiceStatus: "All",
    durationDate: "",
    fromDate: "",
    toDate: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: ['invoiceStatus', 'retentionNumber', 'scheduleRetention', 'paymentStatus', 'invoiceDate', 'dueDate', 'customerName', 'invoiceNumber', 'quotationNumber', 'finalAmount', 'invoiceReminderCount'],
  });



  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    screenType: "Invoices",
    userEmailAddress: '',
    customerEmailAddress: [],
    emailTemplate: ''
  });

  const [values1, setValues1] = useState({
    themeID: ""
  })
  const [screenAccess, setScreenAccess] = useState(false);
  const [totalDebtAmount, setTotalDebtAmount] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        let duration = new URLSearchParams(window.location.search).get('duration');
        let customFrom = new URLSearchParams(window.location.search).get('from');
        let customTo = new URLSearchParams(window.location.search).get('to');
        duration && (values.durationDate = duration)
        customFrom && (values.fromDate = customFrom)
        customTo && (values.toDate = customTo)
        setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
        await getRight();
        await fetchDebts();
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };

    fetchInvoicePdfName();
    fetchData();
  }, [values.invoiceStatus, perPage]);

  const handleDisplayDialogeClick = async (_id) => {
    values1._id = _id;
    if (rows.length === 0) {
      showResMsg(genericMessage.addAtleastOneOrder, 2000, false)
      return;
    } else {
      setSelectedId(_id);
      setDisplayDialogeFlag(!displayDialogeFlag);
    }
  };

  const handleCancel = name => event => {
    setDisplayDialogeFlag(false);
  };

  const handleDisplay = async (s) => {
    setDisplayDialogeFlag(!displayDialogeFlag)
    await downloadInvoice(values1, async (response) => {

      const pdfContent = response.data;
      const binaryPdfData = atob(pdfContent);

      const arrayBuffer = new ArrayBuffer(binaryPdfData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryPdfData.length; i++) {
        uint8Array[i] = binaryPdfData.charCodeAt(i);
      }
      const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      ShowSwalWithButtons(
        '', `Would you like to download the Debt Invoice?`, 'question', darkMode,
        () => {
          const link = document.createElement('a');
          link.href = url;
          link.download = 'Debt_Invoices.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      );
    }, dispatch)

  };


  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    console.log("SCREEN_RIGHT", SCREEN_RIGHT)
    setScreenAccess(SCREEN_RIGHT === 'Full Access');
    // if (SCREEN_RIGHT === "Full Access") {
    //   setScreenAccess(true)
    // }
    // else {
    //   setScreenAccess(false)
    // }
  }




  const fetchDebts = async () => {
    setLoading(true);
    values.perPage = perPage;
    values.token = loginDetails.token;
    await axios.post(appConstants.baseURL + 'invoice/fetchDebts', values)
      .then(
        (res) => {
          console.log("RAHUl", res)
          setRows(res.data.data.docs);
          setTotalRows(res.data.data.totalDocs);
          setTotalDebtAmount(res.data.totalDebt);
          setLoading(false);
        }
      )
      .catch(
        (error) => {
          setLoading(false);
          console.log("Error in fetchDebts =", error.message)
        }
      );
  }
  const fetchInvoicePdfName = async () => {
    fetchInvoicePdfTheme(values, async (data) => {
      if (data.Result_Output.length > 0) {
        values.roleID = data.Result_Output[0]._id;
        setThemeName(await generateDataList(data.Result_Output, "_id", "themeName"));
      }
    }, dispatch);
  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false)
  };


  const handleSend = (templateData) => {
    console.log("templateData", templateData)
    const formdata = new FormData()
    formdata.append("selectedID", templateData.selectedID)
    formdata.append("userEmailAddress", templateData.userEmailAddress)
    formdata.append("customerEmailAddress", [...templateData.customerEmailAddress])
    formdata.append("emailTemplate", JSON.stringify({ ...templateData.emailTemplate }))
    formdata.append("sendMeCopy", templateData.sendMeCopy)
    formdata.append("file", templateData.uploadDocument)
    formdata.append("fileName", new Date());
    formdata.append("businessUserID", values.businessUserID);
    let payload = {
      selectedID: templateData.selectedID,
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
      sendMeCopy: templateData.sendMeCopy,
      invoiceDoc: templateData.uploadDocument,
    };
    dispatch(loadingAction(true));
    ResendEmail(formdata, (data) => {
      let status = data.Result_Status;
      showResMsg(data.Result_Message, 2000, status);
      dispatch(loadingAction(true));
      fetchDebts();
    }, dispatch);
    values.sendEmailFlag = true;
    values.templateValues = payload;
    setOpen(false)
  }

  const handleResendEmail = async (selectedRow) => {
    console.log("selected", selectedRow)
    if (!selectedRow.finalAmount || selectedRow.finalAmount <= 0) {
      toast.error("No item added");
    } else {
      if (AllKeysHaveValue(templateValues)) {
        setOpen(true);
      } else {

        console.log("templateValuesR", templateValues)
        await getEmailAndTemplateForQuotation({
          screenType: templateValues.screenType, contactID: selectedRow.contactID, selectedID: selectedRow._id, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "")
        }, (data) => {
          console.log("datafdfd", data.Result_Output)
          if (data.Result_Status) {
            setTemplateValues(data.Result_Output);
            setOpen(true);
          } else {
            showResMsg(data.Result_Message, 2000, false);
            setOpen(false);
          }
        }, dispatch);
      }
    }

  }


  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handleSort = async (column, sortDirection) => {
    values.sortingField = column.sortField;
    if (sortDirection === "asc") {
      values.sortingType = 1;
    }
    else {
      values.sortingType = -1;
    }
    await fetchDebts();
  };

  const handlePageChange = page => {
    values.page = page;
    fetchDebts();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
    setLoading(false);
  };

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
    if (state.selectedRows.length > 0) {
      setTitle(" ");
    }
    else {
      setTitle("");
      setDeleteHeading("");
    }
  }, []);


  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
      },
    },
    headCells: {
      style: {
        fontWeight: 'bold',
        fontSize: '14px',
        color: "white",
      },
    },
  };

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (values.filterValues.length == "") {
      getSearchResult();

    }
  }, [values.filterValues]);



  let columns = [
    {
      // name: "Invoice Number",
      name: <p style={{ fontSize: "12px" }}>Invoice Number</p>,
      // selector: row => row.invoiceNumber,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.invoiceNumber}</span>
      ),
      sortable: true,
      sortField: 'invoiceNumber',
      left: "true",
    },
    {
      // name: "Retention Number",
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Retention Number</p>,
      // selector: row => row.retentionNumber,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.retentionNumber}</span>
      ),
      sortable: true,
      sortField: 'retentionNumber',
      center: "true",

    },
    {
      // name: "Schedule Retention",
      name: <p style={{ paddingLeft: "30px", fontSize: "12px" }}>Schedule Retention</p>,
      // selector: row => row.scheduleRetention,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.scheduleRetention}</span>
      ),
      sortable: true,
      center: "true",
      sortField: 'scheduleRetention',

    },
    {
      // name: "Quotation Number",
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Quotation Number</p>,
      // selector: row => row.quotationNumber,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.quotationNumber}</span>
      ),
      sortable: true,
      sortField: 'quotationNumber',

      center: 'true',
    },
    {
      // name: "Customer Name",
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Customer Name</p>,
      // selector: row => row.customerName,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.customerName}</span>
      ),
      sortable: true,
      sortField: 'customerName',

    },
    {
      // name: "Invoice Date",
      name: <p style={{ paddingLeft: "18px", fontSize: "12px" }}>Invoice Date</p>,
      // selector: row => row.invoiceDate,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.invoiceDate}</span>
      ),
      sortable: true,
      sortField: 'invoiceDate',
      center: 'true',

    },
    {
      // name: "Due Date",
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Due Date</p>,
      // selector: row => row.dueDate,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.dueDate}</span>
      ),
      sortable: true,
      sortField: 'dueDate',
      center: "true",
    },
    {
      name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>Reminder Sent</p>,
      // selector: row => row.invoiceStatus,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.invoiceReminderCount}</span>
      ),
      sortable: true,
      sortField: 'invoiceReminderCount',
      center: "true",
    },
    {
      name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>Status</p>,
      // selector: row => row.invoiceStatus,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.invoiceStatus}</span>
      ),
      sortable: true,
      sortField: 'invoiceStatus',
      center: "true",
    },
    {
      // name: `Amount (${currency})`,
      name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>{`Amount (${currency})`}</p>,
      // selector: row => currency + " " + row.paymentStatus,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{formatCurrencyAUD(row.paymentStatus)}</span>
      ),
      sortable: true,
      sortField: 'paymentStatus',
      center: "true"
    },

    {
      // name: "Action(s)",
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Action(s)</p>,
      // selector: row => row._id,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{currency + " " + row._id}</span>
      ),
      center: 'true',
      width: "150px",
      cell: row => <IconMenu size="small" row={
        <>
          {/* <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}> */}
          <Grid style={{ width: "100%" }} item>

            {row.invoiceStatus === "Unpaid" && featureAccess ?
              <Link to={`/invoices/edit/${row._id}?status=debt`} disabled={!screenAccess} >
                <p style={darkMode ? { color: "white" } : { color: "black" }} >
                  <TimelineItem color="success"
                    // icon="edit" 
                    icon={<EditIcon className="actionicon" />}
                    // disabled={screenAccess}
                    title="Edit" />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
              </Link>
              : row.invoiceStatus === "Partial Paid" && featureAccess ?
                <Link to={`/invoices/payment/${row._id}?status=debt`} disabled={!screenAccess}>
                  <p style={darkMode ? { color: "white" } : { color: "black" }} >
                    <TimelineItem color="success"
                      // icon="edit" 
                      icon={<EditIcon className="actionicon" />}
                      title="Partial Payment" />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
                </Link>
                :
                <p onClick={() => { !featureAccess && showResMsg(genericMessage.notAllowed, 1000, false) }} style={{ color: darkMode ? "white" : "black", cursor: "not-allowed" }}  >
                  <TimelineItem color="grey"
                    //  icon="edit"
                    icon={<EditIcon className="actionicon" />}
                    title="Edit" style={{ cursor: "not-allowed" }} onClick={() => { !featureAccess && showResMsg(genericMessage.notAllowed, 1000, false) }} />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
            }

          </Grid>
          <Grid style={{ width: "100%" }} item>
            <Link to={`/debts/view/${row._id}`} >
              <p style={darkMode ? { color: "white" } : { color: "black" }}>
                <TimelineItem color="info"
                  // icon="visibility" 
                  icon={<VisibilityIcon className="actionicon" />}
                  title="View" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;View</p>
            </Link>
          </Grid>

          {/* <Grid style={{ width: "100%" }} item >
            {row.invoiceStatus === "Unpaid" && featureAccess ?
              <p onClick={() => handleResendEmail(row._id)} style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess} >
                <TimelineItem color="error"
                  //  icon="markunreadIcon" 
                  icon={<EmailIcon className="actionicon" />}
                  title="Resend Email" onClick={() => handleResendEmail(row._id)} disabled={!screenAccess} />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{row.emailSent ? "Resend Email" : "Send Email"}</p>
              :
              <p onClick={() => { !featureAccess && showResMsg(genericMessage.notAllowed, 1000, false) }} style={{ color: darkMode ? "white" : "black", cursor: "not-allowed" }} >
                <TimelineItem color="grey"
                  //  icon="markunreadIcon"
                  icon={<EmailIcon className="actionicon" />}
                  title="Resend Email" style={{ cursor: "not-allowed" }} onClick={() => { !featureAccess && showResMsg(genericMessage.notAllowed, 1000, false) }} />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Resend Email</p>
            }
          </Grid> */}

          <Grid >
            {row.invoiceStatus !== "Paid" ?
              <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => handleResendEmail(row)} disabled={!screenAccess}>
                <TimelineItem color="error"
                  icon={<EmailIcon className="actionicon" />}
                  title={row.emailSent > 0 ? "Resend Email" : "Send Email"}
                  onClick={() => handleResendEmail(row)} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {row.emailSent > 0 ? "Resend Email" : "Send Email"}</p>
              :
              <p disabled
                style={{ color: darkMode ? "white" : "black", cursor: "not-allowed" }}>
                <TimelineItem color="grey"
                  icon={<EmailIcon className="actionicon" />} disabled={!screenAccess}
                  title="Resend Email" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Resend Email</p>

            }
          </Grid>

          {/* <Grid style={{ width: "100%" }} item >
            <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => { handleDisplayDialogeClick(row._id) }} disabled={!screenAccess}>
              <TimelineItem color="#87CEEB"
                //  icon="downloadIcon"
                icon={<DownloadIcon className="actionicon" />}
                title="Download Debts" onClick={() => { handleDisplayDialogeClick(row._id) }} />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Download Debts</p>
          </Grid> */}
          <Grid style={{ width: "100%" }}>
            <Link to={`/invoices/invoice/${row.invoiceNumber}/${row._id}?type=preview&download`} disabled={!screenAccess}>
              <p style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess}>
                <TimelineItem color="#87CEEB"
                  icon={<DownloadIcon className="actionicon" />}
                  title="Download Invoice"
                //  onClick={() => { handleDisplayDialogeClick(row._id) }}
                />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Preview/Download</p>
            </Link>
          </Grid>
          {/* <Grid style={{ width: "100%" }}>
            <Link to={`/invoices/invoice/${row.invoiceNumber}/${row._id}?type=preview&download`} disabled={!screenAccess}>
              <p style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess}>
                <TimelineItem color="#87CEEB"
                  icon={<DownloadIcon className="actionicon" />}
                  title="Download Debts"
                //  onClick={() => { handleDisplayDialogeClick(row._id) }}
                />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Preview/Download</p>
            </Link>
          </Grid> */}

          {/* </Grid> */}
        </>
      } />,
    },
  ];
  const handleSearchInputValue = useCallback((searchInput) => {
    setValues(prevValues => ({ ...prevValues, filterValues: searchInput }));
  }, []);

  const getSearchResult = useCallback(() => {
    fetchDebts();
  }, [values.filterValues]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Debt" />
          <Grid container display={"flex"} justifyContent="end" mt={2.2} gap={2} >
            <Grid item lg={2.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Status"
                  value={values.invoiceStatus}
                  onChange={(e) => setValues({ ...values, invoiceStatus: e.target.value })}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                  <MenuItem value="Partial Paid">Partial Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6} sx={{ mr: 2 }}>
              <SearchField
                tableBorder={tableBorder}
                searchValue={values.filterValues}
                setSearchValue={handleSearchInputValue}
                getSearchResult={getSearchResult}
              />
              {/* <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchDebts();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchDebts}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              /> */}
            </Grid>

          </Grid>
          {/* <Grid>
            <Typography px={2} sx={{ fontSize: "16px", fontWeight: "600" }}>Total Debt Amount : {totalDebtAmount}</Typography>
          </Grid> */}
          {/* <CardContent> */}
          <BTable
            theme={darkMode ? 'solarized' : 'light'}
            title={title}
            columns={columns}
            data={rows}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            customStyles={customStyles}
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggleCleared}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}
          />
          {/* </CardContent> */}
        </Card>
      </div >

      <LoadingModal loading={loading} />
      {/* <InvoiceModal
        open={displayDialogeFlag}
        handleSave={handleDisplay}
        handleAdd={() => { navigate("/invoicePdfFormat/addInvoicePdfFormat?new=invoice") }}
        handleCancel={handleCancel("closeModalClick")}
        menuData={themeName}
        value={values1.themeID}
        onChange={(e) => setValues1({ ...values1, ["themeID"]: e.target.value })}
      /> */}
      {open && <EmailTemplateModal
        open={open}
        handleClose={handleClose}
        templatesData={templateValues}
        onSend={handleSend}
      />}

    </DashboardLayout>
  );

}

export default InvoicesDebts;
